import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const ActionTypes = Constants.ActionTypes;

module.exports = {

  receiveMembers(members, limited_messages, over_conversation_limit, submit_on_enter, has_paid) {
    AppDispatcher.dispatch({
      type: ActionTypes.MEMBERS_LOAD_SUCCESS,
      members,
      limitedMessages: limited_messages,
      overConversationLimit: over_conversation_limit,
      submitOnEnter: submit_on_enter,
      hasPaid: has_paid,
    });
  },

};
